export default __webpack_public_path__ + "cf32da761dbf2901d55a93779fee6a92.svg";